export default __webpack_public_path__ + "static/media/img-egt-du3.6cd17121.png";